























































































































































































































































































































































































































import {
  Component,
  Vue
} from "@/shared/vuepack";
import Logo from "@/shared/components/Logo.vue";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import {
  FetchState,
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { FeeWaiverType } from "@/employer/types";

@Component({
  components: {
    Logo,
    GenericLoadingSpinner
  }
})
export default class AvidiaTermsFeeSchedule extends Vue {
  userStore = useUserStore();
  enrollmentStore = useEnrollmentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();

  formatCurrency = formatCurrency;

  get monthlyAdminFee () {
    return `${formatCurrency(this.enrollmentStore.feeSchedule.monthlyFeeAmount)}`;
  }

  get scrollContents () {
    return this.$route.name !== RouteNames.FeeSchedulePrint;
  }

  get showLoadingSpinner () {
    return this.enrollmentStore.feeScheduleFetchState !== FetchState.Loaded;
  }

  get partnerName () {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  get showFeeWaiverDisclaimer () {
    return this.enrollmentStore.showWaiver
    && (this.userStore.isIndividualAccountType
    || this.enrollmentStore.feeSchedule.isEmployerBalanceFeeWaiverEnabled);
  }

  mounted () {
    this.enrollmentStore.loadFeeWaiverSettings(this.portalCustomizationStore.partnerId);
    this.enrollmentStore.loadFees();
    this.custodianSettingsStore.getCustodianSettings();
  }
}
